import { globalState, previousState, setCurrentState, setPreviousState, subscribers } from '../internal/stateContainer';
export var emitChange = function (newState) {
    if (globalState !== newState) {
        setPreviousState(globalState);
        if (typeof newState === 'function') {
            setCurrentState(newState(globalState));
        }
        else {
            setCurrentState(newState);
        }
        subscribers.forEach(function (s) { return s.onChange(globalState, previousState); });
    }
};
export var initGlobalState = function (initialState) {
    setPreviousState(undefined);
    setCurrentState(initialState);
};
export var off = function (subscriber) {
    var subIndex = subscribers.indexOf(subscriber);
    subscribers.splice(subIndex, 1);
};
export var subscribe = function (onChange) {
    var subscriber = { onChange: onChange };
    subscribers.push(subscriber);
    subscriber.onChange(globalState, previousState);
    return subscriber;
};
//# sourceMappingURL=subscription.js.map